import HotelsIndicativePricesLegalDisclaimer from './HotelsIndicativePricesLegalDisclaimer';

export default HotelsIndicativePricesLegalDisclaimer;
